import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { http } from "@/lib/api";
import { ArrowLeft, Calendar } from "lucide-react";

export default function ThingsToKnowArchive() {
  const [days, setDays] = useState([]);
  const [selected, setSelected] = useState(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    http.get("/news/archive", { params: { limit_days: 60 } })
      .then((r) => {
        setDays(r.data.days || []);
        if (r.data.days?.length) setSelected(r.data.days[0].date);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (!selected) return;
    http.get("/news", { params: { top25: true, date: selected, limit: 25 } })
      .then((r) => setItems(r.data.items || []));
  }, [selected]);

  return (
    <div data-testid="ttk-archive-page" className="max-w-[1200px] mx-auto px-6 lg:px-10 py-10">
      <Link to="/things-to-know" className="inline-flex items-center gap-1 text-sm underline mb-6" style={{ color: "var(--wofy-primary)" }}>
        <ArrowLeft size={14} /> Back to Today
      </Link>
      <h1 className="font-display text-4xl md:text-5xl leading-tight mb-2">Archive.</h1>
      <p className="text-sm mb-6" style={{ color: "var(--wofy-text-soft)" }}>Every day's Top 25 is permanently kept. Browse by date.</p>

      {loading ? (
        <div className="py-8" style={{ color: "var(--wofy-text-soft)" }}>Loading…</div>
      ) : days.length === 0 ? (
        <div className="py-8 border rounded" style={{ borderColor: "var(--wofy-line)", color: "var(--wofy-text-soft)" }}>
          No archive yet. The daily archive builds up as each day's Top 25 is finalized.
        </div>
      ) : (
        <div className="grid md:grid-cols-[240px_1fr] gap-8">
          <aside>
            <div className="text-xs uppercase tracking-wider mb-3" style={{ color: "var(--wofy-text-soft)" }}>Dates</div>
            <ul className="space-y-1 border-l pl-3" style={{ borderColor: "var(--wofy-line)" }}>
              {days.map((d) => (
                <li key={d.date}>
                  <button
                    data-testid={`ttk-archive-date-${d.date}`}
                    onClick={() => setSelected(d.date)}
                    className={`text-sm text-left w-full px-2 py-1 rounded ${selected === d.date ? "font-semibold" : ""}`}
                    style={{ background: selected === d.date ? "rgba(0,0,0,0.06)" : "transparent" }}
                  >
                    <Calendar size={12} className="inline mr-1 -mt-0.5" />
                    {new Date(d.date).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" })}
                    <span className="ml-2 text-xs" style={{ color: "var(--wofy-text-soft)" }}>({d.count})</span>
                  </button>
                </li>
              ))}
            </ul>
          </aside>
          <section>
            {items.length === 0 ? (
              <div style={{ color: "var(--wofy-text-soft)" }}>Select a date to view its Top 25.</div>
            ) : (
              <ul className="space-y-2">
                {items.map((a, i) => (
                  <li key={a.id}>
                    <Link to={`/things-to-know/${a.id}`} className="grid grid-cols-[24px_1fr] gap-3 py-2 border-b hover:opacity-80" style={{ borderColor: "var(--wofy-line)" }}>
                      <span className="text-xs" style={{ color: "var(--wofy-text-soft)" }}>{i + 1}.</span>
                      <div>
                        <div className="text-xs uppercase tracking-wider mb-0.5" style={{ color: "var(--wofy-primary)" }}>
                          {a.category} · {a.source_name}
                        </div>
                        <div className="text-base leading-snug">{a.title}</div>
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </section>
        </div>
      )}
    </div>
  );
}
